import React from 'react';
import splitHours from '../store/split-hours';

const todayDaysName = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][new Date().getDay()];

export function AddressAndOpeningHours({store, address, showMobileStoreDetail, isMobileDevice, selectedStore, isInPostStoreLocatorRebrandEnabled}) {
  const handleClick = (event) => {
    let containerDiv;
    let arrowSvg;
    if (isMobileDevice) {
      const wrapper = event.target.closest('.opening-times-distance-wrapper');
      containerDiv = wrapper.querySelector('.opening-time');
      arrowSvg = wrapper.querySelector('.flip-arrow');
    } else {
      containerDiv = document.getElementsByClassName('opening-time')[0];
      arrowSvg = document.getElementsByClassName('flip-arrow')[0];
    }

    containerDiv.classList.toggle('opening-times--shown');
    arrowSvg.classList.toggle('flip-arrow--turned');
    window.ga && window.ga('send', 'event', 'new store locator', 'opening times click', store.id);
  }

  return(
    <div className='opening-times-container'>
      <div className="store-address-container-yodel" style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
        <div className="store-address-headline-yodel">
          <div className="store-address-and-image-yodel">
            <img src="/assets/store-locator/yodel-map-icon.svg" alt="address-icon"
              className='store-detail-image' />
            <span itemProp="address" className="store-address">
              {address}
            </span>
          </div>
        </div>
        <div style={{color: "#767676", fontSize: 14}}>
          <span>{store.distance.toFixed(1)} miles</span>
        </div>
      </div>

      {store.locker_location_type &&
        <div style={{display: "flex", direction: "row", paddingBottom: 15}}>
          <img style={{paddingRight: 5}} src={`/assets/store-locator/${store.locker_location_type.toLowerCase()}-icon.svg`} alt="locker-type-icon"/>
          <span style={{color: "#4A4A49"}}>            
            {store.locker_location_type}
          </span>
        </div>
      }
      
      {store.locker_location_description && store.selected &&
        <div style={{display: "flex", direction: "row", paddingBottom: 15}}>
          <img style={{paddingRight: 5}} src="/assets/store-locator/location-icon.svg" alt="locker-location-icon"/>
          <span style={{color: "#4A4A49"}}>
            {store.locker_location_description}
          </span>
        </div>
      }

      {store.phone_number &&
        <div className="store-service-yodel store-service-column">
          <img src="/assets/store-locator/yodel-phone-icon.svg" alt="telephone-icon" />
          <a href={`tel:${store.phone_number}`} className="phone-number">
            {store.phone_number}
          </a>
        </div>
      }


      <div className={`${isMobileDevice ? "store-service-yodel-phase2" : "store-service-yodel"}`}>
        {!store.locker_location_type && store.print_in_store &&
          (
            <div className='store-service-column'>
              <img src="/assets/store-locator/yodel-printer-icon.svg" alt="print-in-store-icon"
                className='print-in-store-image'
                title={isInPostStoreLocatorRebrandEnabled ? 'Print at shop is available here' : 'Print in store is available here'} />
              <span className='print-in-store-text'>{isInPostStoreLocatorRebrandEnabled ? 'Print at shop' : 'Print in store'}</span>
            </div>
          )
        }
      </div>

      <div className="opening-times-distance-wrapper" style={{color: "#4A4A49"}}>
        <div className="opening-times--open-today">
          <div className={isMobileDevice ? "opening-times-text-distance-wrapper" : ""}>
            <div>
              <img src="/assets/store-locator/opening_times.svg" alt="address-icon"
                className='store-detail-image -yodel-hour-image' />
              <span className={`${isMobileDevice ? "open-until-phase2" : "open-until"}`} onClick={handleClick}>
                {store.closing_message}
                <img src="/assets/store-locator/arrow_down.svg" alt="open-hours-image"
                  className={(isMobileDevice && !showMobileStoreDetail) ? 'flip-arrow' : 'flip-arrow flip-arrow--turned'} />
              </span>
            </div>
          </div>

          <div className={(isMobileDevice && !showMobileStoreDetail) ? "opening-time -yodel" : "opening-time -yodel opening-times--shown"}>
            {store.detailed_opening_hours && store.detailed_opening_hours.map(oh =>
              (<div itemProp="openingHours" className={(todayDaysName === oh.days_short) ? 'opening-hours-each -active-day' : 'opening-hours-each'} key={oh.days}>
                <span className='opening-hours-days'>{oh.days}</span>
                {!['24h', 'closed'].includes(oh.hours) ? (
                  <div>
                    <span className='opening-hours-hours'>{splitHours(oh.hours)[0]}</span>
                    <span> - </span>
                    <span className='opening-hours-hours'>{splitHours(oh.hours)[1]}</span>
                    <meta itemProp="openingHours" content={oh.days_short + " " + splitHours(oh.hours)[0] + "-" + splitHours(oh.hours)[1]} />
                  </div>
                ) : (
                  <span className='opening-hours-hours'>{oh.hours}</span>
                )}

              </div>)
            )}
          </div>
        </div>
      </div>

      {store.out_of_area_additional_days > 0 && (
        <div className='none-area-message'>
          <img src="/assets/store-locator/alert-icon.svg" alt="yellow-alert-icon"
             className='store-detail-image' />
          <span>
            For non-mainland addresses, please allow up to an additional {store.out_of_area_additional_days} working day
            {store.out_of_area_additional_days > 1 ? 's' : null} for the delivery of your parcel.
          </span>
        </div>
      )}

      {store.store_of_the_quarter && (
        <div className='store-of-the-quarter'>
          Store of the quarter
          <img src="/assets/store-locator/store-of-quarter-cockade.svg" alt="" />
        </div>
      )}
    </div>
  );
}
